module.exports = __webpack_public_path__ + "img/platform-personalized.d4f4df2e.png";